import React from 'react';
import { Redirect, Route } from 'react-router';

import { getDashboardRoutes } from './dashboard/routes';
import { getDealerLoginRoutes } from './login/routes';
import { getRequestInviteRoutes } from './requestinvite/routes';
import { getListingsRoutes } from './listings/routes';
import { getLeadsRoutes } from './leads/routes';
import { getServiceRoutes } from './service/routes';
import { getAccountRoutes } from './account/routes';

export const getDealerRoutes = (store) => (
  <Route name="dealer">
    <Redirect exact from="/" to="/dealer/login" />
    <Redirect exact from="/dealer" to="/dealer/login" />
    {getDashboardRoutes(store)}
    {getDealerLoginRoutes(store)}
    {getRequestInviteRoutes(store)}
    {getListingsRoutes(store)}
    {getLeadsRoutes(store)}
    {getServiceRoutes(store)}
    {getAccountRoutes(store)}
  </Route>
);
